import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  paperStyle: {
    width: '100%',
    marginTop: 2,
    padding: 0,
    zIndex: 999,
    backgroundColor: '#e6e6e6',
    position: 'absolute',
  },
  chipInput: {},
}));

export default styles;
